import { render, staticRenderFns } from "./webcam.vue?vue&type=template&id=2345b1e0"
import script from "./webcam.vue?vue&type=script&lang=js"
export * from "./webcam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports